const getRecipients = (idDocument, allParties) => {
	const recipients = [];

	allParties.forEach((party) => {
		if (party.idDocuments.includes(idDocument)) {
			const toContacts = party.contactsTo;
			const ccContacts = party.contactsCC;

			toContacts.forEach((contact) => {
				if (!recipients.some((recipient) => recipient.idContact === contact.idContact)) {
					recipients.push(contact);
				}
			})

			ccContacts.forEach((contact) => {
				if (!recipients.some((recipient) => recipient.idContact === contact.idContact)) {
					recipients.push(contact);
				}
			})
		}
	});


	return recipients;
}

const getDocumentType = (idDomain) => {
	switch (idDomain) {
		case 372:
			return 'Credit Note';
		case 373:
			return 'Welcome Letter';
		case 23:
			return 'Evidence of Cover';
		case 370:
			return 'Debit Note';
		case 403:
			return 'Credit Note';
		case 404:
			return 'Debit Note';
		case 371:
			return 'LPAN';
		case 376:
			return 'External Brokerage';
		case 406:
			return 'External Brokerage';
		case 377:
			return 'Third Party';
		case 407:
			return 'Third Party';
		case 983:
			return 'Cover Letter';
		case 375:
			return 'Rebate';
		case 405:
			return 'Rebate';
		case 461:
			return 'Debit Note';
		case 464:
			return 'Credit Note';
		case 604:
			return 'Invoice Tax GST';
		case 690:
			return 'Premium Transfer';
		case 691:
			return 'Premium Transfer';
		case 367:
			return 'Welcome Kit';
		case 450:
			return 'Endorsement Contract';
		case 272:
			return 'Additional Document';
		case 578:
			return 'Signature Document';

		default:
			return null;
	}
}



const needsToUpdate = (party, currentParty) => {
	if (party.subject !== currentParty.subject || party.emailBody !== currentParty.emailBody) {
		throw new Error('You have changed your email information. Please click the update button.');
	}
}

const renderEmails = (contacts) => {
	if (!contacts.length) return '';
	return contacts.map((item) => item.email).join('; ') + ';';
}

export {
	getRecipients,
	getDocumentType,
	needsToUpdate,
	renderEmails
}